import React from "react";
import Input from "../../../../components/FormComponents/Input";
import InlineMasterdataSelection from "../../EditFieldAttribute/InlineMasterdataSelection";
import { getLabelForKey } from "../../../../utils/Config/DefaultConfig/formFieldConfig";

const EditMultiSelectDropdown = (props) => {
  const { editFieldData, setEditFieldData } = props;
  const handleChangeInput = (name, value) => {
    setEditFieldData({ ...editFieldData, [name]: value });
  };
  const handleChangeValidationInput = (name, value) => {
    setEditFieldData({ ...editFieldData, validate: { ...editFieldData.validate, [name]: value } });
  };
  const handleChangeData = (value) => {
    setEditFieldData({ ...editFieldData, data: value });
  };
  return (
    <>
      <Input
        label={getLabelForKey("label")}
        value={editFieldData.label}
        name="label"
        onChange={({ target }) => handleChangeInput(target.name, target.value)}
      />
      <Input
        label={getLabelForKey("form_display_label")}
        value={editFieldData.form_display_label}
        name="form_display_label"
        onChange={({ target }) => handleChangeInput(target.name, target.value)}
      />
      <Input
        label={getLabelForKey("default_value")}
        value={editFieldData.default_value}
        name="default_value"
        onChange={({ target }) => handleChangeInput(target.name, target.value)}
      />
      <div className="field_horizontal_container">
        <Input
          type="checkbox"
          label={getLabelForKey("required")}
          checked={editFieldData.validate.required}
          name="required"
          onChange={({ target }) => handleChangeValidationInput(target.name, target.checked)}
          containerClassName="w_50"
        />
        <Input
          type="checkbox"
          label={getLabelForKey("disable")}
          checked={editFieldData.disable}
          name="disable"
          onChange={({ target }) => handleChangeInput(target.name, target.checked)}
          containerClassName="w_50"
        />
      </div>
      <div className="field_horizontal_container">
        <Input
          type="checkbox"
          label={getLabelForKey("mandatory")}
          checked={editFieldData.validate.mandatory}
          name="mandatory"
          containerClassName="w_50"
          onChange={({ target }) => handleChangeValidationInput(target.name, target.checked)}
        />
        <Input
          type="checkbox"
          label={getLabelForKey("backend_validation")}
          checked={editFieldData.validate.backend_validation}
          name="backend_validation"
          size="medium"
          containerClassName="w_50"
          onChange={({ target }) => handleChangeValidationInput(target.name, target.checked)}
        />
      </div>
      <div className="field_horizontal_container">
        <Input
          type="checkbox"
          label={getLabelForKey("is_searchable")}
          checked={editFieldData.is_searchable}
          name="is_searchable"
          size="medium"
          containerClassName="w_50"
          onChange={({ target }) => handleChangeInput(target.name, target.checked)}
        />
      </div>
      <InlineMasterdataSelection value={editFieldData.data} onChange={handleChangeData} />
      <div className="field_horizontal_container">
        <Input
          label={getLabelForKey("help_text")}
          value={editFieldData.help_text}
          name="help_text"
          onChange={({ target }) => handleChangeInput(target.name, target.value)}
        />
      </div>
    </>
  );
};

export default EditMultiSelectDropdown;
